$(document).on("click", ".question_product,.custom_icons_faq_main .icons_with_text_item_title", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').removeClass('active');
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".faq_question", function () {
  var $current = $(this);
  var $answer = $current.next();

  if ($current.hasClass("active")) {
    $current.removeClass("active");
    $answer.stop(true, true).slideUp(300);
    return;
  }

  // Close all others
  $(".faq_question.active")
    .removeClass("active")
    .next()
    .stop(true, true)
    .slideUp(300);

  // Open current
  $current.addClass("active");
  $answer.stop(true, true).slideDown(300);
});
$(document).on("click", ".faq_question_new_main", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.faq_question_new_main').removeClass('active');
    jQuery('.faq_question_text').removeClass('active');
    jQuery('.faq_question_new_main').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).find('.faq_question_text').toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});




 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });








$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#contact']", function (e) {
  e.preventDefault();
  document.querySelector('#contact').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isAtViewportMidline(el) {
  if (!el || !el.getBoundingClientRect) return false;
  if (!$(el).is(':visible')) return false;

  const rect = el.getBoundingClientRect();
  const vw = window.innerWidth || document.documentElement.clientWidth;
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const midY = vh / 2;

  // horizontally on-screen AND the element spans the middle line
  return rect.left < vw && rect.right > 0 && rect.top < midY && rect.bottom > midY;
}

function runCounters($block) {
  $block.addClass('start_count');
  $block.find('.count_js').each(function () {
    const $c = $(this);
    const target = +($c.data('value') || 0);
    $c.prop('Counter', 0).stop(true).animate(
      { Counter: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) { $c.text(Math.ceil(now)); }
      }
    );
  });
}

function checkCountersInView() {
  $('.custom_counter .icons_with_text_flex').each(function () {
    const $block = $(this);
    if ($block.hasClass('start_count')) return;          // only once
    if (isAtViewportMidline(this)) runCounters($block); // trigger when truly visible
  });
}

$(window).on('scroll load', checkCountersInView);




$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.product_slider_custom_slider_button a.custom_hk_button, .ajax_add_cart ', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
    $.get(window.location.pathname, function (res) {
      var $new = $(res).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($new);
         // Update cart count
      const $newCartCount = $(res).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      
      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
      } else {
        $('.cart_count_js').text('').hide();
      }
      $('#cart-drawer').removeClass('is_empty').addClass('open');
      $('.custom_overlay2').addClass('active');
      this_element.removeClass('loading_hk');
    });
 } 
 });
  });


let lastScrollTop = 0;

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }

  if (scrollTop > lastScrollTop) {
    // scrolling down
    $('body')
      .addClass('scrolling_down')
      .removeClass('scrolling_up');
  } else {
    // scrolling up
    $('body')
      .addClass('scrolling_up')
      .removeClass('scrolling_down');
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // prevent negative values
});



  function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+0;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.hp_section2_text2').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
    $('.hp_works_list1').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});




$(document).on("click", 'a[href="#ingredients"]', function (e) {
 e.preventDefault(); 
$('.popup_main').css('display','flex').addClass('active');
});



$(document).on("click", '.popup_close,.popup_bg', function (e) {
 e.preventDefault(); 
$('.popup_main').hide().removeClass('active');
});




$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});

$(document).on("click", ".trigger_reviews_js_hide", function (e) {
$('.review_with_text_landing_page_item:nth-child(6)~.review_with_text_landing_page_item').hide().removeClass('active');
});





$(document).on("click", ".contact_form_tab", function (e) {
var data_tab = $(this).attr('data_tab');
$('.contact_form_tab').removeClass('active');
$(this).addClass('active');
$('.contact_form_content').hide().removeClass('active');
$('.contact_form_content[data_tab="'+data_tab+'"]').show().addClass('active');

    var url = new URL(window.location.href);
    url.searchParams.set('tab', data_tab);
    window.history.replaceState({}, '', url);
});



$(document).on("click", "a[href='#forgot']", function (e) {
  e.preventDefault();
$('.contact_form_content').hide().removeClass('active');
$('.contact_form_content[data_tab="3"]').show().addClass('active');
$('.joins_contact_section .two_layers_heading').text('Password Reset');
var data_tab = 3;
    var url = new URL(window.location.href);
    url.searchParams.set('tab', data_tab);
    window.history.replaceState({}, '', url);
});

$(document).on("click", "a[href='#login_with_email']", function (e) {
  e.preventDefault();
$('.contact_form_content').hide().removeClass('active');
$('.contact_form_content[data_tab="2"]').show().addClass('active');
$('.joins_contact_section .two_layers_heading').text('Log In');
var data_tab = 2;
    var url = new URL(window.location.href);
    url.searchParams.set('tab', data_tab);
    window.history.replaceState({}, '', url);
});



$(document).on("click", '.contact_form_tab_logins[data_tab="1"]', function (e) {
$('.joins_contact_section .two_layers_heading').text('Join CCC');
});
$(document).on("click", '.contact_form_tab_logins[data_tab="2"]', function (e) {
$('.joins_contact_section .two_layers_heading').text('Log In');
});



$(document).ready(function(){
  var params = new URLSearchParams(window.location.search);
  var active_tab = params.get('tab');

  if(active_tab){
    var $tab = $('.contact_form_tab[data_tab="'+active_tab+'"]');

    if($tab.length){
      $tab.trigger('click'); // triggers the same click logic
    } else {
$('.contact_form_content').hide().removeClass('active');
$('.contact_form_content[data_tab="3"]').show().addClass('active');
$('.joins_contact_section .two_layers_heading').text('Password Reset');
    }
  }

});


$(document).on("click", ".event_item_top", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.event_item_top').removeClass('active');
    jQuery('.event_item_top').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on('click', '.single_location', function () {
  var mapSrc = $(this).attr('map_src');
  if (mapSrc) {
    $('.custom_location_map_main iframe').attr('src', mapSrc);
  }
  $('.single_location').removeClass('active');
  $(this).addClass('active');

});

$(document).on('click', '.reveal_show', function () {

  const $parent = $(this).closest('.icons_with_text_flex');
  $parent.addClass('active');

  const hiddenText = $parent.find('.reveal_hidden').text().trim();

  if (hiddenText) {
    navigator.clipboard.writeText(hiddenText)
      .then(function() {
        console.log('Copied:', hiddenText);
      })
      .catch(function(err) {
        console.error('Copy failed:', err);
      });
  }

});
document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('#CollectionFiltersForm');
  if (!form) return;

  form.addEventListener('change', function () {
    form.submit();
  });

});




$(document).on('click', '.collection_filters_trigger', function () {

  $(this).toggleClass('active');
  $('.collection_hk_flex').toggleClass('active');
});


$(document).on("click", ".hk_filter_title", function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});
$(document).ready(function(){

  $('input[type="password"]').each(function(){

    var $input = $(this);

    if($input.parent().hasClass('hk_password_field')) return;

    $input.wrap('<div class="hk_password_field" style="position:relative;"></div>');

    var $toggle = $('<span class="hk_password_toggle" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;"></span>');

    $toggle.html(`
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
  <path d="M14.6167 12.1167C13.1922 13.2025 11.4576 13.8041 9.66667 13.8334C3.83333 13.8334 0.5 7.16669 0.5 7.16669C1.53657 5.23493 2.97428 3.54719 4.71667 2.21669M7.91667 0.700021C8.49028 0.565754 9.07755 0.498637 9.66667 0.500021C15.5 0.500021 18.8333 7.16669 18.8333 7.16669C18.3275 8.11303 17.7242 9.00397 17.0333 9.82502M11.4333 8.93335C11.2045 9.17898 10.9285 9.37598 10.6218 9.51262C10.3151 9.64926 9.98409 9.72274 9.64841 9.72866C9.31273 9.73458 8.9793 9.67283 8.66801 9.5471C8.35671 9.42136 8.07393 9.23421 7.83654 8.99682C7.59914 8.75942 7.41199 8.47664 7.28626 8.16535C7.16052 7.85405 7.09877 7.52062 7.10469 7.18495C7.11062 6.84927 7.18409 6.51823 7.32073 6.21156C7.45737 5.9049 7.65438 5.62889 7.9 5.40002" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    `);

    $input.after($toggle);

  });

  $(document).on('click', '.hk_password_toggle', function(){
$(this).toggleClass('active');
    var $input = $(this).siblings('input');

    if($input.attr('type') === 'password'){
      $input.attr('type','text');
    } else {
      $input.attr('type','password');
    }

  });

});



  $(document).on('click', '.ticket_popup_close,.ticket_popup_bg', function(){
$('.ticket_popup').hide();
  });

$(document).on("click", 'a[href="#show_ticket"]', function (e) {
 e.preventDefault(); 
$(this).parents('.event_item_bottom_right_inner').find('.ticket_popup').show();
  });
$(document).on("click", 'a[href="#download_ticket"]', function (e) {
 e.preventDefault(); 


  var $ticket = $(this).closest('.ticket_popup_inner');
  var $downloadBtn = $ticket.find('.download_button');
  var $closebtn = $ticket.find('.ticket_popup_close');

  $downloadBtn.hide(); // hide before capture
  $closebtn.hide(); // hide before capture

  setTimeout(function(){

    html2canvas($ticket[0],{
      scale:2,
      useCORS:true
    }).then(function(canvas){

      var link = document.createElement('a');
      link.download = 'ticket.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      $downloadBtn.show();
      $closebtn.show();

    });

  },300);
  });